export default __webpack_public_path__ + "static/media/arrow-top-left.b7841ebc.svg";